import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdCopy: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 11 11" fill="none" {...props}>
      <Path
        d="M1.964 1.964H0V11h9.036V9.036H11V0H1.964v1.964Zm6.679 8.643H.393v-8.25h8.25v8.25ZM10.607.393v8.25H9.036V1.964H2.357V.393h8.25Z"
        fill="currentColor"
      />
      <Path
        d="M4.321 8.643h.393V6.679H6.68v-.393H4.714V4.322h-.393v1.964H2.357v.393h1.964v1.964Z"
        fill="currentColor"
      />
    </Svg>
  );
};

export default PdCopy;
